export interface CVLabels {
  // Section headers
  sectionEducation: string;
  sectionWork: string;
  sectionTraining: string;
  sectionLanguages: string;
  sectionComputer: string;
  sectionDriving: string;
  sectionQualities: string;
  sectionHobbies: string;
  sectionOrganizations: string;
  sectionRecommendations: string;
  sectionDesiredWork: string;

  // Empty state hints
  emptyEducation: string;
  emptyWork: string;
  emptyTraining: string;
  emptyLanguages: string;
  emptyComputer: string;
  emptyDriving: string;
  emptyQualities: string;
  emptyHobbies: string;
  emptyOrganizations: string;
  emptyRecommendations: string;

  // Language skills table columns
  langColLanguage: string;
  langColUnderstanding: string;
  langColSpeaking: string;
  langColWriting: string;
  langNative: string;
  proficiencyLevels: string[];

  // Computer skills categories
  computerOffice: string;
  computerAccounting: string;
  computerOS: string;
  computerProgramming: string;
  computerDatabase: string;

  // Driving
  drivingExperience: string;
  drivingOwnCar: string;

  // Desired work field labels
  desiredLocation: string;
  desiredField: string;
  desiredType: string;
  desiredTime: string;
  desiredPositionType: string;
  desiredPosition: string;
  desiredSalary: string;

  // Buttons
  btnCreate: string;

  // Date helpers
  datePresent: string;
  dateLocale: string;
}

export const CV_LABELS: Record<string, CVLabels> = {
  'Lietuvių': {
    sectionEducation: 'Išsilavinimas',
    sectionWork: 'Darbo patirtis',
    sectionTraining: 'Papildomi mokymai, seminarai, kursai',
    sectionLanguages: 'Kalbų įgūdžiai',
    sectionComputer: 'Darbo kompiuteriu įgūdžiai',
    sectionDriving: 'Vairavimo įgūdžiai',
    sectionQualities: 'Asmeninės savybės',
    sectionHobbies: 'Pomėgiai, hobiai',
    sectionOrganizations: 'Narystė organizacijose',
    sectionRecommendations: 'Rekomendacijos',
    sectionDesiredWork: 'Pageidaujamas darbas',
    emptyEducation: 'Nėra pridėto išsilavinimo.',
    emptyWork: 'Nėra pridėtos darbo patirties.',
    emptyTraining: 'Nėra pridėtų mokymų.',
    emptyLanguages: 'Nėra pridėtų kalbų.',
    emptyComputer: 'Nėra pridėtų kompiuterio įgūdžių.',
    emptyDriving: 'Nėra pridėtų vairavimo įgūdžių.',
    emptyQualities: 'Nepridėta.',
    emptyHobbies: 'Nepridėta.',
    emptyOrganizations: 'Nėra narystės organizacijose.',
    emptyRecommendations: 'Nėra rekomendacijų.',
    langColLanguage: 'Kalba',
    langColUnderstanding: 'Supratimas',
    langColSpeaking: 'Kalbėjimas',
    langColWriting: 'Rašymas',
    langNative: 'gimtoji',
    proficiencyLevels: ['Gerai', 'Vidutiniškai', 'Silpnai'],
    computerOffice: 'Biuro programos',
    computerAccounting: 'Apskaitos programos',
    computerOS: 'Operacinės sistemos',
    computerProgramming: 'Programavimo kalbos',
    computerDatabase: 'Duomenų bazės',
    drivingExperience: 'Stažas',
    btnCreate: '+ Pridėti',
    drivingOwnCar: 'Galiu naudoti nuosavą automobilį darbui',
    desiredLocation: 'Vieta:',
    desiredField: 'Darbo sritis:',
    desiredType: 'Tipas:',
    desiredTime: 'Laikas:',
    desiredPositionType: 'Pareigybių tipas:',
    desiredPosition: 'Pareigybės:',
    desiredSalary: 'Atlyginimas:',
    datePresent: 'dabar',
    dateLocale: 'lt-LT',
  },

  'Anglų': {
    sectionEducation: 'Education',
    sectionWork: 'Work Experience',
    sectionTraining: 'Additional Training, Seminars, Courses',
    sectionLanguages: 'Language Skills',
    sectionComputer: 'Computer Skills',
    sectionDriving: 'Driving Skills',
    sectionQualities: 'Personal Qualities',
    sectionHobbies: 'Hobbies & Interests',
    sectionOrganizations: 'Organisation Memberships',
    sectionRecommendations: 'References',
    sectionDesiredWork: 'Desired Position',
    emptyEducation: 'No education added.',
    emptyWork: 'No work experience added.',
    emptyTraining: 'No training added.',
    emptyLanguages: 'No languages added.',
    emptyComputer: 'No computer skills added.',
    emptyDriving: 'No driving skills added.',
    emptyQualities: 'Not added.',
    emptyHobbies: 'Not added.',
    emptyOrganizations: 'No organisation memberships.',
    emptyRecommendations: 'No references.',
    langColLanguage: 'Language',
    langColUnderstanding: 'Listening',
    langColSpeaking: 'Speaking',
    langColWriting: 'Writing',
    langNative: 'native',
    proficiencyLevels: ['Good', 'Intermediate', 'Weak'],
    computerOffice: 'Office Applications',
    computerAccounting: 'Accounting Software',
    computerOS: 'Operating Systems',
    computerProgramming: 'Programming Languages',
    computerDatabase: 'Databases',
    drivingExperience: 'Experience',
    btnCreate: '+ Add',
    drivingOwnCar: 'I can use my own car for work',
    desiredLocation: 'Location:',
    desiredField: 'Field:',
    desiredType: 'Type:',
    desiredTime: 'Schedule:',
    desiredPositionType: 'Position type:',
    desiredPosition: 'Position:',
    desiredSalary: 'Salary:',
    datePresent: 'present',
    dateLocale: 'en-GB',
  },

  'Rusų': {
    sectionEducation: 'Образование',
    sectionWork: 'Опыт работы',
    sectionTraining: 'Дополнительное обучение, семинары, курсы',
    sectionLanguages: 'Знание языков',
    sectionComputer: 'Навыки работы с компьютером',
    sectionDriving: 'Навыки вождения',
    sectionQualities: 'Личные качества',
    sectionHobbies: 'Хобби и увлечения',
    sectionOrganizations: 'Членство в организациях',
    sectionRecommendations: 'Рекомендации',
    sectionDesiredWork: 'Желаемая работа',
    emptyEducation: 'Образование не добавлено.',
    emptyWork: 'Опыт работы не добавлен.',
    emptyTraining: 'Обучение не добавлено.',
    emptyLanguages: 'Языки не добавлены.',
    emptyComputer: 'Компьютерные навыки не добавлены.',
    emptyDriving: 'Навыки вождения не добавлены.',
    emptyQualities: 'Не добавлено.',
    emptyHobbies: 'Не добавлено.',
    emptyOrganizations: 'Нет членства в организациях.',
    emptyRecommendations: 'Рекомендации отсутствуют.',
    langColLanguage: 'Язык',
    langColUnderstanding: 'Понимание',
    langColSpeaking: 'Говорение',
    langColWriting: 'Письмо',
    langNative: 'родной',
    proficiencyLevels: ['Хорошо', 'Средне', 'Слабо'],
    computerOffice: 'Офисные программы',
    computerAccounting: 'Бухгалтерские программы',
    computerOS: 'Операционные системы',
    computerProgramming: 'Языки программирования',
    computerDatabase: 'Базы данных',
    drivingExperience: 'Стаж',
    btnCreate: '+ Добавить',
    drivingOwnCar: 'Использует личный автомобиль',
    desiredLocation: 'Место:',
    desiredField: 'Сфера:',
    desiredType: 'Тип:',
    desiredTime: 'График:',
    desiredPositionType: 'Тип должности:',
    desiredPosition: 'Должность:',
    desiredSalary: 'Зарплата:',
    datePresent: 'настоящее время',
    dateLocale: 'ru-RU',
  },

  'Vokiečių': {
    sectionEducation: 'Ausbildung',
    sectionWork: 'Berufserfahrung',
    sectionTraining: 'Weiterbildung, Seminare, Kurse',
    sectionLanguages: 'Sprachkenntnisse',
    sectionComputer: 'EDV-Kenntnisse',
    sectionDriving: 'Führerschein',
    sectionQualities: 'Persönliche Eigenschaften',
    sectionHobbies: 'Hobbys & Interessen',
    sectionOrganizations: 'Mitgliedschaften',
    sectionRecommendations: 'Referenzen',
    sectionDesiredWork: 'Gewünschte Stelle',
    emptyEducation: 'Keine Ausbildung hinzugefügt.',
    emptyWork: 'Keine Berufserfahrung hinzugefügt.',
    emptyTraining: 'Keine Weiterbildung hinzugefügt.',
    emptyLanguages: 'Keine Sprachen hinzugefügt.',
    emptyComputer: 'Keine EDV-Kenntnisse hinzugefügt.',
    emptyDriving: 'Keine Führerscheindaten hinzugefügt.',
    emptyQualities: 'Nicht hinzugefügt.',
    emptyHobbies: 'Nicht hinzugefügt.',
    emptyOrganizations: 'Keine Mitgliedschaften.',
    emptyRecommendations: 'Keine Referenzen.',
    langColLanguage: 'Sprache',
    langColUnderstanding: 'Hören',
    langColSpeaking: 'Sprechen',
    langColWriting: 'Schreiben',
    langNative: 'Muttersprache',
    proficiencyLevels: ['Gut', 'Mittelmäßig', 'Schwach'],
    computerOffice: 'Büroprogramme',
    computerAccounting: 'Buchhaltungssoftware',
    computerOS: 'Betriebssysteme',
    computerProgramming: 'Programmiersprachen',
    computerDatabase: 'Datenbanken',
    drivingExperience: 'Erfahrung',
    btnCreate: '+ Hinzufügen',
    drivingOwnCar: 'Eigenes Auto vorhanden',
    desiredLocation: 'Ort:',
    desiredField: 'Bereich:',
    desiredType: 'Typ:',
    desiredTime: 'Arbeitszeit:',
    desiredPositionType: 'Stellentyp:',
    desiredPosition: 'Stelle:',
    desiredSalary: 'Gehalt:',
    datePresent: 'heute',
    dateLocale: 'de-DE',
  },

  'Lenkų': {
    sectionEducation: 'Wykształcenie',
    sectionWork: 'Doświadczenie zawodowe',
    sectionTraining: 'Szkolenia, seminaria, kursy',
    sectionLanguages: 'Znajomość języków',
    sectionComputer: 'Umiejętności komputerowe',
    sectionDriving: 'Prawo jazdy',
    sectionQualities: 'Cechy osobiste',
    sectionHobbies: 'Hobby i zainteresowania',
    sectionOrganizations: 'Członkostwo w organizacjach',
    sectionRecommendations: 'Referencje',
    sectionDesiredWork: 'Oczekiwania zawodowe',
    emptyEducation: 'Brak wykształcenia.',
    emptyWork: 'Brak doświadczenia.',
    emptyTraining: 'Brak szkoleń.',
    emptyLanguages: 'Brak języków.',
    emptyComputer: 'Brak umiejętności.',
    emptyDriving: 'Brak danych.',
    emptyQualities: 'Nie dodano.',
    emptyHobbies: 'Nie dodano.',
    emptyOrganizations: 'Brak członkostwa.',
    emptyRecommendations: 'Brak referencji.',
    langColLanguage: 'Język',
    langColUnderstanding: 'Rozumienie',
    langColSpeaking: 'Mówienie',
    langColWriting: 'Pisanie',
    langNative: 'ojczysty',
    proficiencyLevels: ['Dobrze', 'Średnio', 'Słabo'],
    computerOffice: 'Programy biurowe',
    computerAccounting: 'Oprogramowanie księgowe',
    computerOS: 'Systemy operacyjne',
    computerProgramming: 'Języki programowania',
    computerDatabase: 'Bazy danych',
    drivingExperience: 'Staż',
    btnCreate: '+ Dodaj',
    drivingOwnCar: 'Posiada własny samochód',
    desiredLocation: 'Miejscowość:',
    desiredField: 'Branża:',
    desiredType: 'Typ:',
    desiredTime: 'Czas pracy:',
    desiredPositionType: 'Typ stanowiska:',
    desiredPosition: 'Stanowisko:',
    desiredSalary: 'Wynagrodzenie:',
    datePresent: 'obecnie',
    dateLocale: 'pl-PL',
  },
};

const LANG_ALIASES: Record<string, string> = {
  'English': 'Anglų',
  'Russian': 'Rusų',
  'German': 'Vokiečių',
  'Polish': 'Lenkų',
};

export function getCVLabels(language: string): CVLabels {
  const key = LANG_ALIASES[language] || language;
  return CV_LABELS[key] ?? CV_LABELS['Lietuvių'];
}
